import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { useParams } from "react-router-dom";
import { Meta } from "../../Components/Helpers/Meta";
import "./Climate.styles.css";

// Translation keys retain their original numbering; the document has nine sections.
const policySections = [
    { id: "2", items: ["2.1", { key: "2.2", children: ["2.2.1", "2.2.2", "2.2.3", "2.2.4"] }, "2.3"] },
    { id: "3", items: ["3.1", "3.2", "3.3", "3.4"] },
    { id: "4", items: ["4.1", { key: "4.2", children: ["4.2.1"] }, "4.3", "4.4", "4.5"] },
    { id: "5", items: ["5.1", "5.2", "5.3", "5.4", "5.5", "5.6"] },
    { id: "6", items: ["6.1", "6.2", "6.3", "6.4", "6.5", "6.6"] },
    { id: "7", items: ["7.1", "7.2", "7.2.1", "7.2.2", "7.2.3", { key: "7.3", children: ["7.3.1", "7.3.2"] }, "7.3.3", "7.4"] },
    { id: "8", items: ["8.1", "8.2", "8.3", "8.4"] },
    { id: "9", items: ["9.1", "9.2", "9.3"] },
    { id: "10", items: ["10.1", "10.2", "10.3", "10.4", "10.5", "10.6"] },
];

const PolicyList = ({ items, t, nested = false }) => (
    <ul className={nested ? "climate-policy-targets" : "climate-policy-points"}>
        {items.map((item) => {
            const key = typeof item === "string" ? item : item.key;
            return (
                <li key={key}>
                    {t(`climate-policy-${key}`)}
                    {item.children && <PolicyList items={item.children} t={t} nested />}
                </li>
            );
        })}
    </ul>
);

const Climate = () => {
    const { t } = useTranslation();
    const { lang } = useParams();

    return (
        <div>
            <Meta title={t("climate-policy-title")} description={t("climate-policy-1")} lang={lang} />
            <Navbar />
            <div className="c-wrapper">
                <div className="c-hero">
                    <div className="c-hero-background">
                        <picture>
                            <img
                                className="c-hero-image"
                                alt=""
                                src={require("../../assets/hero/climate-photo.jpg")}
                            />
                        </picture>
                    </div>
                    <div className="c-hero-body">
                        <div className="c-about-caption">
                            <div
                                className="c-caption-section"
                                style={{ color: "#fff", textAlign: "center" }}
                            >
                                {t("sustainability")}
                            </div>
                            <h1 className="c-caption-header" id="climate-policy-title">
                                {t("climate-policy-title")}
                            </h1>
                        </div>
                    </div>
                </div>

                <main className="c-container climate-policy">
                    <article aria-labelledby="climate-policy-title" lang={lang}>
                        <div className="climate-policy-introduction">
                            {[1, 2, 3, 4, 5].map((key) => (
                                <p key={key}>{t(`climate-policy-${key}`)}</p>
                            ))}
                        </div>

                        <h2>{t("climate-policy-title-1.1")}</h2>
                        <ol className="climate-policy-sections">
                            {policySections.map(({ id, items }) => (
                                <li key={id}>
                                    <section aria-labelledby={`climate-section-${id}`}>
                                        <h3 id={`climate-section-${id}`}>
                                            {t(`climate-policy-title-${id}`)}
                                        </h3>
                                        <PolicyList items={items} t={t} />
                                    </section>
                                </li>
                            ))}
                        </ol>

                        <div className="climate-policy-conclusion">
                            {[11, 12, 13].map((key) => (
                                <p key={key}>{t(`climate-policy-${key}`)}</p>
                            ))}
                        </div>
                        <footer className="climate-policy-signoff">
                            <p><time dateTime="2026-09-02">02.09.2026</time></p>
                            <p>Oğuz Özmen</p>
                            <p>CEO</p>
                        </footer>
                    </article>
                </main>
            </div>
        </div>
    );
};

export default Climate;
